export default __webpack_public_path__ + "static/media/modalImg1.d7330bb7.svg";